<template>
    <b-col cols="12">
        <template v-if="asientos_seleccionados.length > 0 || asientos.length > 0">
            <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                <b-col class="mb-3" cols="12">
                    <b-form-checkbox v-model="mismo_precio">Mismo precio para todos los asientos</b-form-checkbox>
                </b-col>
                <b-col cols="12" v-if="!mismo_precio">
                    <h1>Asientos seleccionados:</h1>
                    <ul>
                        <li v-for="(asiento, index) in combinedAsientos" :key="index">
                            <template v-if="asiento.fila != 0">
                                Fila: {{ asiento.fila }} - Asiento: {{ asiento.asientoName }}
                            </template>
                            <template v-else>
                                {{ ++index }} - Sin numerar
                            </template>
                            
                            <div class="form-group">
                                <label for="precio">Precio</label>
                                <ValidationProvider 
                                    :name="'Precio entrada ' + index" 
                                    rules=""
                                    mode="passive" 
                                    v-slot="{ errors }"
                                >
                                    <multiselect
                                        v-if="asiento.precios"
                                        placeholder="Seleccione un precio"
                                        v-model="asiento.precioSelect"
                                        :show-labels="false"
                                        :options="asiento.precios"
                                        label="descripcion"
                                        :custom-label="asiento.customLabel"
                                        style="width: 97.3%"
                                        :class="(errors[0] ? 'is-invalid' : '')"
                                    />

                                </ValidationProvider>
                            </div>
                        </li>
                    </ul>
                </b-col>
                <b-col cols="12" v-else>
                    <div class="form-group">
                        <label for="precio">Precio</label>
                        <ValidationProvider 
                            :name="'Precio entradas'"
                            mode="passive" 
                            v-slot="{ errors }"
                        >
                            <multiselect
                                v-if="combinedAsientos[0].precios"
                                placeholder="Seleccione un precio"
                                v-model="precio_seleccionado"
                                :show-labels="false"
                                :options="combinedAsientos[0].precios"
                                label="descripcion"
                                :custom-label="combinedAsientos[0].customLabel"
                                :class="(errors[0] ? 'is-invalid' : '')"
                                @select="combinedAsientos.forEach(asiento => asiento.precioSelect = precio_seleccionado)"
                                @remove="combinedAsientos.forEach(asiento => asiento.precioSelect = null)"
                            />

                        </ValidationProvider>
                    </div>
                </b-col>
                <b-col cols="12">                    
                    <div class="form-group">
                        <label for="descuento">Descuento</label>
                        <select v-model="descuento" class="form-control" id="select-descuento">
                            <option value="0">Sin descuento</option>
                            <option v-for="(descuento, index) in configuracion.descuentos_disponibles" :key="index" :value="descuento">{{ descuento }}%</option>
                        </select>
                    </div>
                </b-col>
                <b-col cols="12">
                    <FormInput id="email" label="Email" name="Email" v-model="emailValue" rules="required|email"/>
                </b-col>
                <b-col class="mb-3" cols="12">
                    <b-form-checkbox v-model="varios_pedidos">¿Permitir varios pedidos en la misma reserva?</b-form-checkbox>
                </b-col>
                <b-col cols="12" v-if="varios_pedidos">
                    <FormInput id="localizador" label="Localizador" name="Localizador" v-model="localizador" rules="required"/>
                </b-col>
                <b-col cols="12">
                    <b-button :disabled="loading" type="submit">Enviar</b-button>
                </b-col>
            </ValidationObserver> 
        </template>
    </b-col>
</template>

<script>
    export default {
        props: {
            asientos_seleccionados: {
                type: Array,
                default: () => []
            },
            asientos: {
                type: Array,
                default: () => []
            },
            configuracion: {
                type: Object,
                required: true
            },
            loading: {
                type: Boolean,
                default: false
            },
            email: {
                type: String,
                default: ''
            },
            descuento: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                emailValue: this.email,
                localizador: null,
                mismo_precio: true,
                precio_seleccionado: null,
                varios_pedidos: false
            };
        },
        computed: {
            combinedAsientos() {
                if(this.asientos.length > 0){
                    return [
                        ...this.asientos.map(asiento => ({
                        ...asiento,
                        asientoName: asiento.name,
                        customLabel: this.customLabelPlano,
                        precioSelect: null
                        }))
                    ];
                } else {
                    return [
                        ...this.asientos_seleccionados.map(asiento => ({
                        ...asiento,
                        asientoName: asiento.asiento,
                        customLabel: this.customLabel,
                        precioSelect: null
                        }))
                    ];
                }
            },
        },
        methods: {
            customLabel(option) {
                return `${option.descripcion} - ${option.precio}€`;
            },
            customLabelPlano(option) {
                return `${option.description} - ${option.precio}€`;
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                const validAsientos = this.combinedAsientos.every(asiento => asiento.precioSelect);
                if (!validAsientos) {
                    this.$toast.error('Debe seleccionar un precio por asiento');
                    return;
                }

                if (isValid) {
                    this.$emit('submit', this.combinedAsientos, this.emailValue, this.descuento, this.varios_pedidos, this.localizador);
                } else {
                    this.$nextTick(() => {
                        this.$scrollTo('.is-invalid', 100);
                    });
                }
            }
        }
    };
</script>